export default () => ({
    // Активность кнопки
    is_active: false,

    // Свойства для текста и подписей
    button_text: '',
    tickets_left_text: '',
    tickets_left_text_short: '',

    clip_path: null,

    isMiddleMouseButtonDown: false,

    // Таймеры и состояние для активации
    _activationTimer: null,
    _activationInterval: null,
    _salesStartTimestamp: null,
    _isScheduled: false,

    eventData: {
        postId: '',
        postTitle: '',
        postPermalink: '',
        postThumbnailUrl: '',
        eventStartAt: '',
        salePercent: 0,
        ticketsLeft: 0,
    },

    /**
     * Инициализация кнопки
     */
    init() {
        const dataset = this.$el.dataset;

        // Маска для кнопки со скидкой
        if (parseInt(dataset.salePercent ?? 0) > 0) {
            this.clip_path = this.getClipPath();
        }

        // Инициализация EventData
        this.eventData.postId           = dataset.postId ?? '';
        this.eventData.postTitle        = dataset.postTitle ?? '';
        this.eventData.postPermalink    = dataset.postPermalink ?? '';
        this.eventData.postThumbnailUrl = dataset.postThumbnailUrl ?? '';
        this.eventData.eventStartAt     = dataset.eventStartAt ?? '';
        this.eventData.salePercent      = parseInt(dataset.salePercent ?? 0);
        this.eventData.ticketsLeft      = parseInt(dataset.ticketsLeft ?? 0);

        // Установка начального состояния текста
        this.button_text             = dataset.btnTextInitial ?? '';
        this.tickets_left_text       = dataset.ticketsLeftText ?? '';
        this.tickets_left_text_short = dataset.ticketsLeftTextShort ?? '';

        // Запуск таймера, если необходимо
        this._isScheduled = dataset.isScheduled === '1';

        if (this._isScheduled) {
            this.is_active = false;
            this.setupActivationTimer(dataset.salesStartAt);
        } else {
            this.is_active = true; // Если не запланировано, то активно сразу
        }

        // Добавляем обработчик для проверки при возвращении на вкладку
        this.setupVisibilityHandler();
    },

    /**
     * Настройка таймера активации
     */
    setupActivationTimer(salesStartAt) {
        const salesStartDate = new Date(salesStartAt);

        if (isNaN(salesStartDate.getTime())) {
            console.warn('Invalid sales start date:', salesStartAt);
            this.activateButton();
            return;
        }

        this._salesStartTimestamp = salesStartDate.getTime();

        // Проверяем текущее время
        if (this.shouldActivate()) {
            this.activateButton();
            return;
        }

        // Устанавливаем основной таймер
        this.setMainTimer();

        // Устанавливаем интервальную проверку каждые 500мс
        this._activationInterval = setInterval(() => {
            if (this.shouldActivate()) {
                this.activateButton();
            }
        }, 500);
    },

    /**
     * Устанавливает основной setTimeout таймер
     */
    setMainTimer() {
        const delay = this._salesStartTimestamp - Date.now();

        if (delay <= 0) {
            this.activateButton();
            return;
        }

        // Ограничиваем максимальную задержку setTimeout (около 24 дней)
        const maxDelay    = 2147483647; // Math.pow(2, 31) - 1
        const actualDelay = Math.min(delay, maxDelay);

        this._activationTimer = setTimeout(() => {
            if (this.shouldActivate()) {
                this.activateButton();
            } else {
                // Если время еще не пришло, устанавливаем новый таймер
                this.setMainTimer();
            }
        }, actualDelay);
    },

    /**
     * Проверяет, должна ли кнопка быть активирована
     */
    shouldActivate() {
        if (!this._isScheduled || this.is_active) {
            return false;
        }

        return Date.now() >= this._salesStartTimestamp;
    },

    /**
     * Настройка обработчика видимости страницы
     */
    setupVisibilityHandler() {
        const handleVisibilityChange = () => {
            if (!document.hidden && this._isScheduled && !this.is_active) {
                if (this.shouldActivate()) {
                    this.activateButton();
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleVisibilityChange);

        // Сохраняем ссылки для очистки при уничтожении
        this._visibilityHandler = handleVisibilityChange;
    },

    /**
     * Метод для переключения в активное состояние
     */
    activateButton() {
        if (this.is_active) {
            return; // Уже активна
        }

        this.is_active = true;

        // Очищаем таймеры
        this.clearActivationTimers();

        // Обновляем текст и подписи
        this.button_text             = this.$el.dataset.btnTextActive ?? this.button_text;
        this.tickets_left_text       = this.$el.dataset.activeTicketsLeftText ?? '';
        this.tickets_left_text_short = this.$el.dataset.activeTicketsLeftTextShort ?? '';

        console.log('Button activated at:', new Date().toISOString());
    },

    /**
     * Очищает все таймеры активации
     */
    clearActivationTimers() {
        if (this._activationTimer) {
            clearTimeout(this._activationTimer);
            this._activationTimer = null;
        }

        if (this._activationInterval) {
            clearInterval(this._activationInterval);
            this._activationInterval = null;
        }
    },

    /**
     * Очистка при уничтожении компонента
     */
    destroy() {
        this.clearActivationTimers();

        // Удаляем обработчики событий
        if (this._visibilityHandler) {
            document.removeEventListener('visibilitychange', this._visibilityHandler);
            window.removeEventListener('focus', this._visibilityHandler);
        }
    },

    link: {
        ['@click.debounce']() {
            this.handleClick();
        },
        ['@mousedown'](e) {
            if (e.button === 1) {
                this.isMiddleMouseButtonDown = true;
            }
        },
        ['@mouseup.debounce'](e) {
            if (e.button === 1 && this.isMiddleMouseButtonDown) {
                this.isMiddleMouseButtonDown = false;
                this.handleClick();
            }
        },
        ['@mouseleave']() {
            this.isMiddleMouseButtonDown = false;
        }
    },

    handleClick() {
        console.log('tickets buttons click', this.eventData);

        const ticketsButtonClickEvent = new CustomEvent('ticketsButtonClick', {
            detail: this.eventData,
            bubbles: true,
            composed: true
        });

        document.dispatchEvent(ticketsButtonClickEvent);
    },

    getClipPath() {
        // Базовый размер шрифта для конвертации px в rem (1rem = 16px)
        const ROOT_FONT_SIZE = 16;

        // Конвертируем значения из px в числа для использования в rem
        let radius       = 6.5 / ROOT_FONT_SIZE;
        let padding      = 22 / ROOT_FONT_SIZE;
        let cornerOffset = 4 / ROOT_FONT_SIZE;
        let points       = [];
        let angle_step   = 6;

        // левый верхний угол
        points.push(`-${cornerOffset}rem -${cornerOffset}rem`);

        // начало окружности
        points.push(`calc(100% - ${radius * 2 + padding}rem) -${cornerOffset}rem`);

        // верхняя окружность
        for (let angle = 0; angle <= 2 * Math.PI; angle += Math.PI / angle_step) {
            let dx = Math.cos(angle) * radius;
            let dy = Math.sin(angle) * radius;
            points.push(`calc(100% - ${dx + padding + radius}rem) ${dy}rem`);
        }

        // конец окружности
        points.push(`calc(100% - ${padding}rem) -${cornerOffset}rem`);

        // правый верхний угол
        points.push(`calc(100% + ${cornerOffset}rem) -${cornerOffset}rem`);

        // правый нижний угол
        points.push(`calc(100% + ${cornerOffset}rem) calc(100% + ${cornerOffset}rem)`);

        // начало окружности
        points.push(`calc(100% - ${padding}rem) calc(100% + ${cornerOffset}rem)`);

        // нижняя окружность
        for (let angle = 2 * Math.PI; angle >= 0; angle -= Math.PI / angle_step) {
            let dx = Math.cos(angle) * radius;
            let dy = Math.sin(angle) * radius;
            points.push(`calc(100% - ${dx + padding + radius}rem) calc(100% - ${dy}rem)`);
        }

        // конец окружности
        points.push(`calc(100% - ${radius * 2 + padding}rem) calc(100% + ${cornerOffset}rem)`);

        // Перфорация
        const perforationOffsetRight = 58 / ROOT_FONT_SIZE;
        const perforationWidth       = 2 / ROOT_FONT_SIZE;

        const perforationHeight = 5 * 2;
        const perforationGap    = 5 * 2;
        const perforationMargin = 5;
        const startWithGap      = true;
        let perforationY        = 100 + perforationMargin + perforationGap + perforationHeight;
        if (!startWithGap) {
            perforationY -= perforationGap;
        }

        // Начальная точка перед выполнением перфорации
        points.push(`calc(100% - ${perforationOffsetRight}rem) calc(100% + ${cornerOffset}rem)`);

        while (perforationY > -4 - perforationHeight - Math.abs(perforationMargin)) {

            // определяем позицию следующей перфорации по Y
            perforationY = perforationY - perforationHeight - perforationGap;

            // левый нижний угол перфорации
            points.push(`calc(100% - ${perforationOffsetRight}rem) ${perforationY + perforationHeight}%`);

            // правый нижний угол перфорации
            points.push(`calc(100% - ${perforationOffsetRight - perforationWidth}rem) ${perforationY + perforationHeight}%`);

            // правый верхний угол перфорации
            points.push(`calc(100% - ${perforationOffsetRight - perforationWidth}rem) ${perforationY}%`);

            // левый верхний угол перфорации
            points.push(`calc(100% - ${perforationOffsetRight}rem) ${perforationY}%`);
        }

        // Возвращаем координату после перфорации на исходную точку
        points.push(`calc(100% - ${perforationOffsetRight}rem) calc(100% + ${cornerOffset}rem)`);

        // левый нижний угол
        points.push(`-${cornerOffset}rem calc(100% + ${cornerOffset}rem)`);

        return 'polygon(' + points.join(', ') + ')';
    },

    /**
     * Обработчик директивы x-intersect
     *
     * @param element
     */
    handleFirstIntersection(element) {
        if (element.closest('.fixed') !== null) {
            return;
        }

        if (Alpine.store('global').isParticleCooldownActive()) {
            return;
        }

        Alpine.store('global').setParticleCooldown();

        // noinspection JSUnresolvedReference
        if (this.$root.dataset?.salePercent) {
            // noinspection JSUnresolvedReference
            window.createParticlesAtElementCenter(element, 'percent', this.$root.dataset.salePercent);
        }
    }
});